import styled from 'styled-components';
import { Button } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  margin: 0 auto;
  max-width: 1100px;
  width: 100%;

  @media (max-width: 1220px) {
    padding: 0 2rem;
  }
`;

export const Header = styled.header`
  padding-top: 30px;
  text-align: center;
`;

export const SearchBox = styled.div`
  max-width: 600px;
  width: 100%;
  margin: 0 auto;
`;

export const StatusButton = styled(Button)`
  padding: 3px 6px;
  min-width: 30px;
  background-color: #328796;
`;

export const StatusButtonNotification = styled(Button)`
  padding: 3px 6px;
  min-width: 30px;
  background: #6e3296;

  &:hover {
    background-color: #6e3296;
  }
`;
